module.exports = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  helpers = helpers || Handlebars.helpers;
  


  return "<svg id=\"cmhr-mc-loading-indicator\" class=\"loading\" width=\"200\" height=\"200\">\n    <circle cx=100 cy=100 r=50 />\n</svg>\n";});